import { useEffect } from "react";
import { useTranslation } from "react-i18next";
import { Chip } from "./Chip";
import { DAY_KEYS } from "../branchFields";

const ALL = DAY_KEYS.map((_, i) => i);

// أيام العمل قابلة للضغط؛ وعطلة نهاية الأسبوع = الأيام المتبقّية تلقائياً (للعرض فقط، غير قابلة للضغط)،
// مع ضمان بقاء يوم عطلة واحد على الأقل (لا يمكن اختيار الأيام السبعة كأيام عمل).
export const DayPicker = ({ form, set }) => {
  const { t } = useTranslation();
  const work = (form.work_days || []).filter((d) => ALL.includes(d)).sort((a, b) => a - b);
  const weekend = ALL.filter((i) => !work.includes(i));

  useEffect(() => {
    if ((form.weekend_days || []).join(",") !== weekend.join(",")) set("weekend_days", weekend);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [work.join(",")]);

  const toggleWork = (index) => {
    if (work.includes(index)) set("work_days", work.filter((d) => d !== index));
    else if (work.length < ALL.length - 1) set("work_days", [...work, index].sort((a, b) => a - b));
  };

  return (
    <>
      <div className="sm:col-span-2">
        <p className="label-xs mb-2">{t("branches.workDays")}</p>
        <div className="grid grid-cols-5 gap-1.5" data-testid="branch-work_days">
          {DAY_KEYS.map((day, index) => (
            <Chip key={day} className="w-full text-center" testId={`branch-work_days-${day}`} active={work.includes(index)} onClick={() => toggleWork(index)}>
              {t(`days.${day}`)}
            </Chip>
          ))}
        </div>
      </div>
      <div className="sm:col-span-2">
        <p className="label-xs mb-2">{t("branches.weekendDays")}</p>
        <div className="grid grid-cols-5 gap-1.5" data-testid="branch-weekend_days">
          {weekend.length === 0 ? (
            <span className="text-xs text-muted-foreground">—</span>
          ) : (
            weekend.map((index) => (
              <Chip key={DAY_KEYS[index]} className="w-full text-center" testId={`branch-weekend_days-${DAY_KEYS[index]}`} active readOnly>
                {t(`days.${DAY_KEYS[index]}`)}
              </Chip>
            ))
          )}
        </div>
        <p className="text-xs text-muted-foreground mt-2" data-testid="branch-weekend_days-hint">{t("branches.weekendHint")}</p>
      </div>
    </>
  );
};
